module.exports = __webpack_public_path__ + "static/site-1748442708190/img/right-arrow.4eb4f426.svg";